import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { Route, Routes } from "react-router-dom";
import Stepper from "react-stepper-horizontal";
import Detail from "./Detail";
import PaymentTerms from "./PaymentTerms";
import QuotationTenderingContext from "../QuotationTenderingContext";
import Summary from "./Summary";

const Construction = (props) => {
  const { step } = useContext(QuotationTenderingContext);

  return (
    <>
      <div className="tendering-quotation__stepper">
        <div className="tendering-quotation__stepper__content">
          <Stepper
            steps={[
              { title: "Details" },
              { title: "Payment Terms" },
              { title: "Summary" },
            ]}
            activeStep={step - 1}
            activeColor="#013565"
            completeColor="#013565"
            activeTitleColor="#013565"
            completeBarColor="#013565"
            completeTitleColor="#013565"
            defaultColor="#BEBEBE"
            defaultBarColor="#BEBEBE"
            defaultTitleColor="#9D9D9D"
            circleFontSize={16}
            titleFontSize={12}
            titleTop={8}
            lineMarginOffset={0}
          />
        </div>
      </div>
      <Routes>
        <Route path="details" element={<Detail />} />
        <Route path="payment-terms" element={<PaymentTerms />} />
        <Route path="summary" element={<Summary />} />
      </Routes>
    </>
  );
};

Construction.propTypes = {};

export default Construction;
